///mastersim/list
export const MASTER_SIM_LIST = "MASTER_SIM_LIST";
export const MASTER_SIM_LIST_SUCCESS = "MASTER_SIM_LIST_SUCCESS";
export const MASTER_SIM_LIST_FAILURE = "MASTER_SIM_LIST_FAILURE";
///mastersim/data
export const MASTER_SIM_DATA = "MASTER_SIM_DATA";
export const MASTER_SIM_DATA_SUCCESS = "MASTER_SIM_DATA_SUCCESS";
export const MASTER_SIM_DATA_FAILURE = "MASTER_SIM_DATA_FAILURE";
///mastersim/companies
export const MASTER_SIM_COMPANIES = "MASTER_SIM_COMPANIES";
export const MASTER_SIM_COMPANIES_SUCCESS = "MASTER_SIM_COMPANIES_SUCCESS";
export const MASTER_SIM_COMPANIES_FAILURE = "MASTER_SIM_COMPANIES_FAILURE";
///mastersim/create
export const MASTER_SIM_CREATE = "MASTER_SIM_CREATE";
export const MASTER_SIM_CREATE_SUCCESS = "MASTER_SIM_CREATE_SUCCESS";
export const MASTER_SIM_CREATE_FAILURE = "MASTER_SIM_CREATE_FAILURE";
///mastersim/update
export const MASTER_SIM_UPDATE = "MASTER_SIM_UPDATE";
export const MASTER_SIM_UPDATE_SUCCESS = "MASTER_SIM_UPDATE_SUCCESS";
export const MASTER_SIM_UPDATE_FAILURE = "MASTER_SIM_UPDATE_FAILURE";
///mastersim/delete
export const MASTER_SIM_DELETE = "MASTER_SIM_DELETE";
export const MASTER_SIM_DELETE_SUCCESS = "MASTER_SIM_DELETE_SUCCESS";
export const MASTER_SIM_DELETE_FAILURE = "MASTER_SIM_DELETE_FAILURE";
///mastersim/sync
export const MASTER_SIM_SYNC = "MASTER_SIM_SYNC";
export const MASTER_SIM_SYNC_SUCCESS = "MASTER_SIM_SYNC_SUCCESS";
export const MASTER_SIM_SYNC_FAILURE = "MASTER_SIM_SYNC_FAILURE";
///mastersim/register
export const MASTER_SIM_REGISTER = "MASTER_SIM_REGISTER";
export const MASTER_SIM_REGISTER_SUCCESS = "MASTER_SIM_REGISTER_SUCCESS";
export const MASTER_SIM_REGISTER_FAILURE = "MASTER_SIM_REGISTER_FAILURE";
///mastersim/activate
export const MASTER_SIM_ACTIVATE = "MASTER_SIM_ACTIVATE";
export const MASTER_SIM_ACTIVATE_SUCCESS = "MASTER_SIM_ACTIVATE_SUCCESS";
export const MASTER_SIM_ACTIVATE_FAILURE = "MASTER_SIM_ACTIVATE_FAILURE";
///mastersim/suspend
export const MASTER_SIM_SUSPEND = "MASTER_SIM_SUSPEND";
export const MASTER_SIM_SUSPEND_SUCCESS = "MASTER_SIM_SUSPEND_SUCCESS";
export const MASTER_SIM_SUSPEND_FAILURE = "MASTER_SIM_SUSPEND_FAILURE";
///mastersim/assign
export const MASTER_SIM_ASSIGN = "MASTER_SIM_ASSIGN";
export const MASTER_SIM_ASSIGN_SUCCESS = "MASTER_SIM_ASSIGN_SUCCESS";
export const MASTER_SIM_ASSIGN_FAILURE = "MASTER_SIM_ASSIGN_FAILURE";
///mastersim/unassign
export const MASTER_SIM_UNASSIGN = "MASTER_SIM_UNASSIGN";
export const MASTER_SIM_UNASSIGN_SUCCESS = "MASTER_SIM_UNASSIGN_SUCCESS";
export const MASTER_SIM_UNASSIGN_FAILURE = "MASTER_SIM_UNASSIGN_FAILURE";
